<template>
  <div data-v-e928e504="" data-v-2ac6a5fc="" class="home-page login-bar-stance">
    <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i class="grab" @click="$parent.goNav('/hongbao')"></i>
      <img @click="changhongbashow" src="/static/image/close_popup.png" />
    </div>
    <div style="position: fixed; top: 0; left: 0; z-index: 999; width: 100vw; height: 100vh; background: rgb(0 0 0 / 66%)" data-v-a691d594="" data-v-710c460e="" data-v-29c11a50="" class="popup-background" v-if="tanshow && $store.state.appInfo.index_modal == 1">
      <div data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="safety-tip">
        <i data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="close" @click="changtanshow"></i>
        <div data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="title">欢迎来到{{ $store.state.appInfo.title }}</div>
        <div data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="unbind-box" v-html="$store.state.appInfo.webcontent"></div>
      </div>
    </div>
    <div data-v-26f3bfed="" data-v-e928e504="" class="banner" style="background: none">
      <div data-v-26f3bfed="" class="swiper swiper-container-horizontal swiper-container-ios">
        <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
          <div data-v-26f3bfed="" class="swiper-slide swiper-slide-active" style="width: 375px" v-for="(item, index) in bannerList" :key="index"><img data-v-26f3bfed="" :src="item.src" alt="" class="banner-img" /></div>
        </div>
        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
      </div>
    </div>
    <div data-v-e928e504="" class="main">
      <div data-v-e928e504="" class="block">
        <div data-v-68ac6eb0="" data-v-e928e504="" class="marquee">
          <div data-v-68ac6eb0="" class="marquee-inner">
            <!-- <ul data-v-68ac6eb0="" class="notice-list" style="animation-duration: 10s"> -->
            <ul data-v-68ac6eb0="" class="notice-list" style="animation-duration: 30s">
              <li v-for="(item, index) in homenoticelis" :key="index" data-v-68ac6eb0="" class="notice-item" style="padding-left: 334px">
                <span data-v-68ac6eb0="">{{ item }}</span>
              </li>
            </ul>
          </div>
          <span data-v-68ac6eb0="" class="mask-right"></span>
        </div>
        <div data-v-4335771e="" data-v-e928e504="" class="game-list">
          <div data-v-4335771e="" class="table-block" style="overflow: hidden">
            <div data-v-4335771e="" class="col left">
              <div data-v-4335771e="" class="col-img"><img data-v-4335771e="" src="/static/image/sub_banner_left.png.4207be40.webp" alt="" /></div>
            </div>
            <div data-v-4335771e="" class="col left">
              <div data-v-4335771e="" class="col-img"><img data-v-4335771e="" src="/static/image/b5.png_.d77d2d2b.webp" alt="" /></div>
            </div>
          </div>
          <!-- 真人 -->
          <div data-v-4335771e="" class="baccarat-list">
            <div data-v-4335771e="" class="t clear">
              <div data-v-4335771e="" class="title-left"><span data-v-4335771e="" class="icon icon01 icon-webp"></span><span data-v-4335771e="">真人</span></div>
              <!-- <span data-v-4335771e="" class="link">新手教学</span> -->
            </div>
            <div data-v-4335771e="" class="banner webp" v-if="false">
              <!-- <span data-v-4335771e="" class="icon-try webp"></span> -->
              <p data-v-4335771e="" class="lt">AG国际厅</p>
              <p data-v-4335771e="" class="txt2">单注最高200万 豪客首选</p>
            </div>
            <div data-v-4335771e="" class="dew-figure-wrapper" v-if="false">
              <div data-v-3174463f="" data-v-4335771e="">
                <div data-v-3174463f="" id="zoodWarp" class="banner-block">
                  <div data-v-3174463f="" id="zoodVidD051" class="tble_block zoodBox" data-vid="D051" style="">
                    <div data-v-3174463f="" class="col">
                      <div data-v-3174463f="" id="shuffleD051" class="shuffle" style="display: none">
                        <img data-v-3174463f="" src="/static/image/shuffle.5552f056.gif" alt="" class="shuffle-img" />
                        <p data-v-3174463f="" class="shuffle-text">洗牌中</p>
                      </div>
                      <!-- <canvas data-v-3174463f="" id="canvasD051" width="240" height="90"></canvas> -->
                    </div>
                    <div data-v-3174463f="" class="col right">
                      <div data-v-3174463f="" class="timer">
                        <!-- <p data-v-3174463f="" class="st"><span data-v-3174463f="" class="counterText">本局剩余</span></p>
                        <p data-v-3174463f="" class="time counter">00:16</p> -->
                        <span data-v-3174463f="" @click="$parent.openGamePage('ag', '1', '')" class="btn loginZood" data-vid="D051" style="width: 105px; margin-left: -30px">快速入桌</span>
                      </div>
                    </div>
                  </div>
                  <div data-v-3174463f="" id="zoodLoading" class="delayLoading ball-clip-rotate" style="display: none">
                    <div data-v-3174463f=""></div>
                    <span data-v-3174463f="">正在加载推荐桌台</span>
                  </div>
                </div>
              </div>
              <div data-v-4335771e=""></div>
            </div>
          </div>
          <div data-v-4335771e="" class="ul-auto-wrap">
            <ul data-v-4335771e="" class="index-games">
              <li data-v-4335771e="" class="with-try" style="overflow: hidden; position: relative" v-for="(item, index) in realbetList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
                <div data-v-4335771e=""><img style="min-height: 90px" data-v-4335771e="" :src="`/static/image/realbet/${item.platform_name}.jpg`" lazy="loaded" /></div>
                <div style="position: absolute; bottom: 5px; left: 5px; color: #fff">{{ item.name }}</div>
              </li>
            </ul>
          </div>
          <div data-v-4335771e="" class="popups-dialog" style="display: none">
            <div data-v-4335771e="" class="popLuckyDraw"><a data-v-4335771e="" class="close-button"></a><a data-v-4335771e="" class="pop-button-l"></a><a data-v-4335771e="" class="pop-button-r"></a></div>
          </div>
        </div>
        <div data-v-4335771e="" data-v-e928e504="" class="game-list">
          <!-- 电竞投注 -->
          <div data-v-4335771e="" class="baccarat-list" style="padding-top: 0">
            <div data-v-4335771e="" class="t clear">
              <div data-v-4335771e="" class="title-left"><span data-v-4335771e="" class="icon icon01 icon-webp"></span><span data-v-4335771e="">电竞投注</span></div>
            </div>
          </div>
          <div data-v-4335771e="" class="ul-auto-wrap">
            <ul data-v-4335771e="" class="index-games" style="display: flex; flex-wrap: wrap">
              <li data-v-4335771e="" class="with-try" style="overflow: hidden; position: relative" v-for="(item, index) in gamingList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
                <div data-v-4335771e=""><img data-v-4335771e="" style="min-height: 90px" :src="`/static/image/gaming/${item.platform_name}.webp`" lazy="loaded" /></div>
                <div style="position: absolute; bottom: 2px; left: 5px; color: #fff">{{ item.name }}</div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 电子游艺 -->
        <div data-v-5648ec66="" data-v-e928e504="" class="other-games">
          <div data-v-5648ec66="" class="t clear">
            <div data-v-5648ec66="" class="title-left"><span data-v-5648ec66="" class="icon icon-controller icon-webp"></span>电子游艺</div>
            <span data-v-4335771e="" @click="$parent.goNav('/games')" class="link">更多游戏</span>
          </div>
          <ul data-v-5648ec66="" class="game-list clearfix">
            <li data-v-5648ec66="" class="with-try">
              <div @click="$parent.goNav('/games')" style="min-height: 243px" data-v-5648ec66="" class="games game1"><img data-v-5648ec66="" data-src="https://91a2c0front.rieeng.com/cdn/91a2c0FM/static/img/og10.png_.b6a409ec.webp" src="/static/image/og10.png_.b6a409ec.webp" lazy="loaded" /></div>
            </li>
            <li data-v-5648ec66="" class="with-try">
              <div v-for="(item, index) in conciseList" style="height: 113px" :key="index" v-if="item.app_state == 1 && index < 2" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" data-v-5648ec66="" class="games game2">
                <img data-v-5648ec66="" :src="`/static/image/concise/${item.platform_name}dz.png`" lazy="loaded" />
                <span style="font-size: 15px; color: #fff; position: absolute; bottom: 3px; left: 3px">{{ item.name }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 彩票投注 和 棋牌 -->
      <div data-v-e928e504="" class="block block2">
        <div data-v-e928e504="" class="list" style="padding-bottom: 0">
          <div data-v-e928e504="" class="t clear">
            <div data-v-e928e504="" class="title-left"><span data-v-e928e504="" class="icon icon-heart icon-webp"></span>体育投注</div>
          </div>
          <div data-v-e928e504="" class="auto-wrap">
            <ul data-v-e928e504="" class="index-promo">
              <li data-v-e928e504="" style="padding-top: 0" v-for="(item, index) in sportList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
                <div data-v-e928e504="" class="act">
                  <img data-v-e928e504="" alt="" :src="`/static/image/sport/${item.platform_name}ty.png`" lazy="loaded" />
                  <span style="font-size: 10px; position: absolute; top: 3px; left: 10px; color: #fff">{{ item.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div data-v-e928e504="" class="list" style="padding-bottom: 0">
          <div data-v-e928e504="" class="t clear">
            <div data-v-e928e504="" class="title-left"><span data-v-e928e504="" class="icon icon-heart icon-webp"></span>彩票投注</div>
          </div>
          <div data-v-e928e504="" class="auto-wrap">
            <ul data-v-e928e504="" class="index-promo">
              <li data-v-e928e504="" style="padding-top: 0" v-for="(item, index) in lotteryList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
                <div data-v-e928e504="" class="act">
                  <img data-v-e928e504="" alt="" :src="`/static/image/lottery/${item.platform_name}cp.png`" lazy="loaded" />
                  <span style="font-size: 10px; position: absolute; bottom: 3px; left: 4px; color: #fff">{{ item.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div data-v-e928e504="" class="list">
          <div data-v-e928e504="" class="t clear">
            <div data-v-e928e504="" class="title-left"><span data-v-e928e504="" class="icon icon-heart icon-webp"></span>棋牌游戏</div>
          </div>
          <div data-v-e928e504="" class="auto-wrap">
            <ul data-v-e928e504="" class="index-promo">
              <li data-v-e928e504="" style="padding-top: 0" v-for="(item, index) in jokerList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
                <div data-v-e928e504="" class="act">
                  <img data-v-e928e504="" alt="" :src="`/static/image/joker/${item.platform_name}qp.png`" lazy="loaded" />
                  <span style="font-size: 10px; position: absolute; bottom: 3px; left: 4px; color: #fff">{{ item.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div data-v-e928e504="" class="block block2">
        <div data-v-e928e504="" class="list" v-if="false">
          <div data-v-e928e504="" class="t clear">
            <div data-v-e928e504="" class="title-left"><span data-v-e928e504="" class="icon icon-heart icon-webp"></span>优惠活动</div>
            <span data-v-e928e504="" class="link" @click="$parent.goNav('/activeList')">更多优惠</span>
          </div>
          <div data-v-e928e504="" class="auto-wrap">
            <ul data-v-e928e504="" class="index-promo">
              <li data-v-e928e504="">
                <div data-v-e928e504="" class="act">
                  <img data-v-e928e504="" alt="" data-src="https://91a2c0front.rieeng.com/cdn/91a2c0FM/_wms/img/_l/_promo/home_promo_list-0997c5ab256e4ad6f1311d078c0cb33cf.png_.webp" src="/static/image/home_promo_list-0997c5ab256e4ad6f1311d078c0cb33cf.png_.webp" lazy="loaded" />
                </div>
              </li>
              <li data-v-e928e504="">
                <div data-v-e928e504="" class="act">
                  <img data-v-e928e504="" alt="" data-src="https://91a2c0front.rieeng.com/cdn/91a2c0FM/_wms/img/_l/_promo/home_promo_list-11ba5fed5a13d0fe28d16ed6e93323b93.png_.webp" src="/static/image/home_promo_list-11ba5fed5a13d0fe28d16ed6e93323b93.png_.webp" lazy="loaded" />
                </div>
              </li>
              <li data-v-e928e504="">
                <div data-v-e928e504="" class="act">
                  <img data-v-e928e504="" alt="" data-src="https://91a2c0front.rieeng.com/cdn/91a2c0FM/_wms/img/_l/_promo/home_promo_list-2021705de20e5cf95b735808f647beb17.png_.webp" src="/static/image/home_promo_list-2021705de20e5cf95b735808f647beb17.png_.webp" lazy="loaded" />
                </div>
              </li>
              <li data-v-e928e504="">
                <div data-v-e928e504="" class="act">
                  <img data-v-e928e504="" alt="" data-src="https://91a2c0front.rieeng.com/cdn/91a2c0FM/_wms/img/_l/_promo/home_promo_list-3c6aca931a249566d2695c50326bad380.png_.webp" src="/static/image/home_promo_list-3c6aca931a249566d2695c50326bad380.png_.webp" lazy="loaded" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div data-v-e928e504="" class="list show-list no-padding-top"> -->
        <div data-v-e928e504="" class="list show-list">
          <div data-v-e928e504="" class="t clear">
            <div data-v-e928e504="" class="title-left"><span data-v-e928e504="" class="icon icon-diamond icon-webp"></span>实力展示</div>
            <span data-v-e928e504="" class="link" @click="$parent.goNav('/sponsor')">更多风采</span>
          </div>
          <div data-v-e928e504="" class="auto-wrap">
            <ul data-v-e928e504="">
              <li data-v-e928e504="">
                <div data-v-e928e504="" class="picture-wrapper">
                  <img data-v-e928e504="" alt="" data-src="https://91a2c0front.rieeng.com/cdn/91a2c0FM/_wms/img/_l/_promo/mien_list-019ce713e94378d2f9be74b858ed7d515-2.png_.webp" src="/static/image/mien_list-019ce713e94378d2f9be74b858ed7d515-2.png_.webp" lazy="loaded" />
                </div>
                <div data-v-e928e504="" class="info">
                  <h3 data-v-e928e504="">2022.08</h3>
                  <p data-v-e928e504="">{{ $store.state.appInfo.title }}收购乐橙娱乐</p>
                </div>
              </li>
              <li data-v-e928e504="">
                <div data-v-e928e504="" class="picture-wrapper">
                  <img data-v-e928e504="" alt="" data-src="https://91a2c0front.rieeng.com/cdn/91a2c0FM/_wms/img/_l/_promo/mien_list-157932b56e09278955039300b65731ee6-2.png_.webp" src="/static/image/mien_list-157932b56e09278955039300b65731ee6-2.png_.webp" lazy="loaded" />
                </div>
                <div data-v-e928e504="" class="info">
                  <h3 data-v-e928e504="">2021.07</h3>
                  <p data-v-e928e504="">韦斯利·斯内德</p>
                </div>
              </li>
              <li data-v-e928e504="">
                <div data-v-e928e504="" class="picture-wrapper">
                  <img data-v-e928e504="" alt="" data-src="https://91a2c0front.rieeng.com/cdn/91a2c0FM/_wms/img/_l/_promo/mien_list-2047fc09fdfb833a27a2b6c31e37cf997-2.png_.webp" src="/static/image/mien_list-2047fc09fdfb833a27a2b6c31e37cf997-2.png_.webp" lazy="loaded" />
                </div>
                <div data-v-e928e504="" class="info">
                  <h3 data-v-e928e504="">2021.06</h3>
                  <p data-v-e928e504="">卢卡斯·波多尔斯基</p>
                </div>
              </li>
              <li data-v-e928e504="">
                <div data-v-e928e504="" class="picture-wrapper">
                  <img data-v-e928e504="" alt="" data-src="https://91a2c0front.rieeng.com/cdn/91a2c0FM/_wms/img/_l/_promo/mien_list-30334e7b0bd6221561e10d87df888ef1a-2.jpg_.webp" src="/static/image/mien_list-30334e7b0bd6221561e10d87df888ef1a-2.jpg_.webp" lazy="loaded" />
                </div>
                <div data-v-e928e504="" class="info">
                  <h3 data-v-e928e504="">2020.02</h3>
                  <p data-v-e928e504="">{{ $store.state.appInfo.title }}赞助卡利亚里</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div data-v-e928e504="" class="block block2">
        <div data-v-e928e504="" class="list kf-group">
          <div data-v-e928e504="" class="t clear">
            <div data-v-e928e504="" class="title-left"><span data-v-e928e504="" class="icon icon-flag icon-webp"></span>{{ $store.state.appInfo.title }}集团旗下</div>
          </div>
          <div data-v-e928e504="" class="group">
            <img
              data-v-e928e504=""
              alt=""
              class="group-bg"
              data-src="data:image/webp;base64,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"
              src="data:image/webp;base64,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"
              lazy="loaded"
            />
            <ul data-v-e928e504="" class="group-list clearfix">
              <li data-v-e928e504="" class="group-item"><a data-v-e928e504="" href="javascript:void (0);" class="group-item-bg bg1 webp"></a></li>
              <li data-v-e928e504="" class="group-item"><a data-v-e928e504="" href="javascript:void (0);" class="group-item-bg bg6 webp"></a></li>
              <li data-v-e928e504="" class="group-item"><a data-v-e928e504="" href="javascript:void (0);"  class="group-item-bg bg5 webp"></a></li>
              <li data-v-e928e504="" class="group-item"><a data-v-e928e504="" href="javascript:void (0);"  class="group-item-bg bg3 webp"></a></li>
              <li data-v-e928e504="" class="group-item"><a data-v-e928e504="" href="javascript:void (0);"  class="group-item-bg bg2 webp"></a></li>
              <li data-v-e928e504="" class="group-item"><a data-v-e928e504="" href="javascript:void (0);"  class="group-item-bg bg4 webp"></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div data-v-64785503="" data-v-2ac6a5fc="" class="footerWrap login-bar-stance">
      <div data-v-64785503="" class="links">
        <span data-v-64785503=""><a @click="$parent.goNav('/faq')" style="color: #cca352">帮助中心</a></span>
        <span data-v-64785503="" class="br">|</span>
        <span data-v-64785503=""><a @click="$parent.goNav('/about')" style="color: #cca352">关于我们</a></span>
      </div>
      <p data-v-64785503="" class="copyright">© 2022 $store.state.appInfo.title. All Rights Reserved.</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {
      homenoticelis: [],
      bannerList: [],
      realbetList: [],
      jokerList: [],
      gamingList: [],
      sportList: [],
      lotteryList: [],
      hongbashow: true,
      conciseList: [],
      tanshow: true,
    };
  },
  created() {
    let that = this;
    that.getGameList();

    that.homenotice(); //获取公告
    that.getBanList(); //获取轮播
  },
  methods: {
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    getGameList() {
      let that = this;

      that.$apiFun.get('/api/game/list', { category: '' }).then(res => {
        if (res.code == 200) {
          let list = res.data;
          // that[name] = res.data;
          list.forEach(el => {
            if (el.category_id == 'realbet') {
              that.realbetList.push(el);
            }
            if (el.category_id == 'joker') {
              that.jokerList.push(el);
            }
            if (el.category_id == 'gaming') {
              that.gamingList.push(el);
            }
            if (el.category_id == 'sport') {
              that.sportList.push(el);
            }
            if (el.category_id == 'lottery') {
              that.lotteryList.push(el);
            }
            if (el.category_id == 'concise') {
              that.conciseList.push(el);
            }
          });
        }
      });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
      });
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;

    var mySwiper = new Swiper('.swiper', {
      slidesPerView: '1',
    });
    $(window).scroll(function () {
      if ($(document).scrollTop() <= 50) {
        $('.header-container').removeClass('headerBg');
        $('#headerBefore').css('height', '');
      } else {
        $('.header-container').addClass('headerBg');
        $('#headerBefore').css('height', '50px');
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.game-list .ul-auto-wrap ul li {
  margin-top: 14px;
}
.game-list .baccarat-list {
  position: relative;
  padding: 15px 13px 0px 0;
}
.banner-block[data-v-3174463f] {
  position: relative;
  min-height: 58px;
}
.game-list .baccarat-list .dew-figure-wrapper {
  min-height: 58px;
}
.other-games[data-v-5648ec66] {
  display: block;
  padding: 15px 15px 0px 15px;
  /* margin-bottom: 15px; */
}
.home-page .main .block .list .auto-wrap ul li .act img[data-v-e928e504] {
  width: 151px;
  height: 90px;
}
.game-list .ul-auto-wrap ul li {
  width: 45% !important;
  min-width: auto !important;
  min-height: 80px !important;
  height: auto !important;
  margin-right: 10px !important;
}
.game-list .ul-auto-wrap ul li {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/index.vue